<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="160"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_fiveData'"
    :sqOptions="[ 6, 48]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesFive',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 52)
      } else if (value === 2) {
        this.$emit('handleProgress', 19)
      } else if (value === 3) {
        this.$emit('handleProgress', 23)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
